import React from 'react';
import { Tag, Tooltip } from 'antd';
import { GiCrossedSwords } from 'react-icons/gi';
import { FaRegCircle } from 'react-icons/fa';
import { RiGamepadFill } from 'react-icons/ri';

/**
 * Etiqueta (només icona) que indica si una entrega/ejercici s'ha fet en Mode
 * Desafiament, Mode Joc (Unity) o per la via normal.
 *
 * Origen (per entrega) o origen_success (per problema):
 *  - 2       => Mode Joc (Unity) (icona de comandament, lila)
 *  - 1       => Mode Desafiament / IDE (icona d'espases, vermell)
 *  - 0       => via normal (icona de cercle, gris)
 *  - null    => desconegut / no completat => NO es mostra res
 *
 * Es pot cridar de dues maneres:
 *  1) Passant origenSuccess / origen directament.
 *  2) Passant una fila d'enviament sencera via `record`.
 */
interface Props {
    origenSuccess?: number | null;
    origen?: number | null;
    record?: any;
    // Es manté per compatibilitat; ara quan és desconegut mai es mostra res.
    hideWhenPending?: boolean;
}

// Intenta resoldre el valor d'origen d'un enviament provant diversos noms de camp.
function resolveOrigen(record: any): number | null {
    if (!record || typeof record !== 'object') return null;
    const candidates = ['origen', 'origen_success', 'origenSuccess', 'origin', 'mode', 'modo', 'modo_desafio'];
    for (const key of candidates) {
        const v = record[key];
        if (v !== undefined && v !== null && v !== '') {
            const n = Number(v);
            if (!Number.isNaN(n)) return n;
        }
    }
    return null;
}

const ModoDesafioTag: React.FC<Props> = ({ origenSuccess, origen, record }) => {
    let value: number | null = null;
    if (origenSuccess !== undefined && origenSuccess !== null) {
        value = Number(origenSuccess);
    } else if (origen !== undefined && origen !== null) {
        value = Number(origen);
    } else if (record !== undefined) {
        value = resolveOrigen(record);
    }

    // Desconegut / no completat => no mostrem res
    if (value === null || value === undefined || Number.isNaN(value)) {
        return null;
    }

    if (Number(value) === 2) {
        return (
            <Tooltip title="Modo Juego (Unity - recompensa en el juego)">
                <Tag color="purple" style={{ borderRadius: 8, padding: '0 6px', display: 'inline-flex', alignItems: 'center' }}>
                    <RiGamepadFill />
                </Tag>
            </Tooltip>
        );
    }

    if (Number(value) === 1 || Number(value) > 2) {
        return (
            <Tooltip title="Mode Desafiament (dona recompensa)">
                <Tag color="volcano" style={{ borderRadius: 8, padding: '0 6px', display: 'inline-flex', alignItems: 'center' }}>
                    <GiCrossedSwords />
                </Tag>
            </Tooltip>
        );
    }

    return (
        <Tooltip title="Via normal (no dona recompensa)">
            <Tag color="default" style={{ borderRadius: 8, padding: '0 6px', display: 'inline-flex', alignItems: 'center' }}>
                <FaRegCircle />
            </Tag>
        </Tooltip>
    );
};

export default ModoDesafioTag;
